import { ABLoginManager } from '../lib/ab/login';
import { the_reset_token } from '../lib/me/login';
import { meSetDefaultProducer, the_producer } from '../lib/me/producer';
import { $analytics } from '../lib/y/analytics';
import { $location } from '../lib/y/location';

export function producerShowLogin(_flow: string) {
    const manager = new ABLoginManager('producer', {
        close: true,
        mobile_fs: true,
        extra_params: window.ab_producer_invite && { role_invite: window.ab_producer_invite.id + window.ab_producer_invite.token },
        prefilled_email: window.ab_producer_invite && window.ab_producer_invite.dst_email,
        on_success: () => {
            if(!the_producer) {
                meSetDefaultProducer();
            }

            $location.navigate(['events']);
        },
        on_identity: _info => {
            // producer_signup.showIdentity(flow, info);
        },
    });

    if(the_reset_token) {
        manager.showResetDialog();
    } else if(window.ab_producer_invite) {
        $analytics.track('Onboarding started');
        manager.showSignupDialog();
    } else {
        manager.showLoginDialog();
    }
}
